/**
 * @deprecated Legacy URL `/firstcalls` (no hyphen). Bookmarks and external links redirect to the
 * canonical `/first-calls` route. Do not add navigation to this path.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/firstcalls')({
  beforeLoad: () => {
    throw redirect({ to: '/first-calls' });
  },
});
